export default __webpack_public_path__ + "static/media/dajia.3034b6ab.png";